import React, { Fragment } from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input } from 'reactstrap';
import { ModalTransports } from '../../components/transports/ModalTransports';
import { useTransport } from '../../hooks/transports/useTransport';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';

export const IndexTransports = () => {

    const {
        transports, method,
        name, abbreviation, code, handleInputChange, validaciones,
        toggle, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        showDeleteAlert, modalAlert, closeDeleteAlert,
        closeDialog, handleExcelTransport, loadingExcel,
        handleClearTransport, searchTransport, handleSearchTransport
    } = useTransport();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_transport)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_transport)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };



    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title="Tipos de transporte" /> */}
            <Row>
                <Col md="12">
                    <Card>
                        <CardBody className="p-1">
                            <TitleDataTable
                                titleTable="Listado de tipos de transporte"
                                buttonActions={handleExcelTransport}
                                titleButton="Listado de tipos de transporte"
                                isDisbled={loadingExcel}
                                loadingIsDisabled={loadingExcel}
                                titleCreate="Crear Trasporte"
                                buttonActionsCreate={handleCreate}
                                actionInput={handleSearchTransport}
                                valueFilter={searchTransport}
                                filterLocalStorage={true}
                                cleanFilterLocalStorage={handleClearTransport}
                            />
                            <div className="table-responsive">
                                <DataTable
                                    value={transports}
                                    paginator
                                    rows={10}
                                    responsiveLayout="scroll"
                                    rowsPerPageOptions={[10, 50, 100]}
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img
                                                src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                style={{ width: "32%" }}
                                                alt="Sin resultados"
                                            />
                                            <br />
                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                No se encontraron resultados.
                                            </p>
                                        </div>
                                    }
                                >
                                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                    <Column
                                        field="name"
                                        header="Nombre"
                                        sortable
                                        body={(rowData) => (
                                            <span style={{ fontWeight: "bold" }}>
                                                {rowData.name}
                                            </span>
                                        )}
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                    />

                                    <Column
                                        field="abbreviation"
                                        sortable
                                        header="Abreviación"
                                        body={(rowData) => (
                                            <span style={{ fontWeight: "bold" }}>
                                                {rowData.abbreviation}
                                            </span>
                                        )}
                                        headerStyle={headerStyle}
                                        style={cellStyle} />

                                    <Column
                                        field="code"
                                        sortable
                                        header="Código"
                                        body={(rowData) => {

                                            return (
                                                <span
                                                    style={{
                                                        width: "100px",
                                                        textAlign: "center",
                                                        color: "#fff",
                                                        backgroundColor: "#1fbff0",
                                                        padding: "4px 0px",
                                                        borderRadius: "12px",
                                                        fontSize: "12px",
                                                        display: "inline-block",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    {rowData.code}
                                                </span>
                                            );
                                        }}
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                    />



                                    <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                </DataTable>
                            </div>

                        </CardBody>
                    </Card>

                    <ModalTransports
                        {
                        ...{
                            modal, modalTitle, closeDialog, method,
                            loading, validaciones,
                            name, abbreviation, code, handleInputChange,
                            saveCreate, saveUpdate, saveDelete
                        }
                        }
                    />

                    {showDeleteAlert && (
                        <AlertDataTable
                            titleAlert="Eliminar transporte"
                            visibleAlert={modalAlert}
                            onHideAlert={closeDeleteAlert}
                            sizeAlert="medium-dialog delete-method"
                            messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el transporte?"
                            alert1={true}
                            titleAlert1={name}
                            buttonAcept
                            titleNotLoading="Eliminar"
                            titleDanger="Cancelar"
                            actionAcept={saveDelete}
                            maskClassName="custom-total-mask"
                            newDesingDialog={true}
                            iconNewDialog="fa fa-trash-o f-20"
                            headerColor="#8b0000"
                            newDesingDialogDelete={true}
                            closable={false}
                        />
                    )}

                </Col>
            </Row>
        </Fragment>
    )
}
